export default [
  {
    imgSrc: "/rss-source/wordpress.svg",
    name: "WordPress",
    url: "wordpress.com",
  },
  {
    imgSrc: "/rss-source/substack.svg",
    name: "Substack",
    url: "substack.com",
  },
  {
    imgSrc: "/rss-source/ghost.png",
    name: "Ghost",
    url: "ghost.org",
  },
  {
    imgSrc: "/rss-source/medium.svg",
    name: "Medium",
    url: "medium.com",
  },
  {
    imgSrc: "/rss-source/tumblr.svg",
    name: "Tumblr",
    url: "tumblr.com",
    widthPx: 77,
    height: 16,
  },
  {
    imgSrc: "/rss-source/reddit.svg",
    name: "Reddit",
    url: "reddit.com",
  },
  {
    imgSrc: "/rss-source/mastodon.svg",
    name: "Mastodon",
    url: "mastodon.com",
  },
  {
    imgSrc: "/rss-source/hackernews.svg",
    name: "Hacker News",
    url: "news.ycombinator.com",
  },
  {
    imgSrc: "/rss-source/stackoverflow.svg",
    name: "Stack Overflow",
    url: "stackoverflow.com",
  },
  {
    imgSrc: "/rss-source/github.svg",
    name: "GitHub",
    url: "github.com",
  },
  {
    imgSrc: "/rss-source/odysee.svg",
    name: "Odysee",
    url: "odysee.com",
  },
  {
    imgSrc: "/rss-source/youtube.svg",
    name: "YouTube",
    url: "youtube.com",
  },
  {
    imgSrc: "/rss-source/youtube.svg",
    name: "YouTube Playlists",
    url: "youtube.com",
  },
  {
    imgSrc: "/rss-source/dribbble.svg",
    name: "Dribbble",
    url: "dribbble.com",
  },
  {
    imgSrc: "/rss-source/facebook.svg",
    name: "Facebook",
    url: "facebook.com",
  },
];
